import { Controller } from '@hotwired/stimulus';

/**
 * Pushes announcement_link_click to GTM dataLayer when user clicks an announcement CTA link.
 * Tracks: who (user_id), which announcement (announcement_id), link_url, cta_text.
 */
export default class extends Controller {
  static values = {
    announcementId: String,
    linkUrl: String,
    ctaText: { type: String, default: '' }
  }

  connect() {
    this.boundHandleClick = this.handleClick.bind(this);
    this.element.addEventListener('click', this.boundHandleClick);
  }

  disconnect() {
    this.element.removeEventListener('click', this.boundHandleClick);
  }

  handleClick() {
    if (typeof window.dataLayer === 'undefined') return;

    const userIdMeta = document.querySelector('meta[name="ga-user-id"]');
    const userId = userIdMeta?.getAttribute('content') || undefined;

    window.dataLayer.push({
      event: 'announcement_link_click',
      announcement_id: this.announcementIdValue || undefined,
      link_url: this.linkUrlValue || this.element.getAttribute('href') || undefined,
      cta_text: this.ctaTextValue || undefined,
      user_id: userId
    });
  }
}
